import { render, staticRenderFns } from "./ProductNotificationsCard.vue?vue&type=template&id=5706bd60&scoped=true"
import script from "./ProductNotificationsCard.vue?vue&type=script&lang=js"
export * from "./ProductNotificationsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductNotificationsCard.vue?vue&type=style&index=0&id=5706bd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706bd60",
  null
  
)

export default component.exports